<template>
	<v-dialog
		class="dialog"
		v-model="visible"
		max-width="400"
		persistent
	>
		<v-alert
			class="mb-0"
			border="top"
			colored-border
			color="error"
		>
			<div class="main-content">
				<div>
					<v-icon color="#F45252" class="mr-2">
						mdi-alert-circle
					</v-icon>
				</div>
				<div>
					<div class="title-text">{{ title }}</div>
					<div class="content-text">{{ content }}</div>
				</div>
			</div>
			<div class="button mt-4">
				<v-btn class="text-capitalize" outlined color="rgba(25, 42, 62, 0.7)" @click="$emit('cancel')">
					{{ cancel }}
				</v-btn>
				<v-btn depressed color="error" class="ml-2 white--text text-capitalize" @click="$emit('ok')">{{ okText }}
					<v-icon right>
						mdi-close
					</v-icon>
				</v-btn>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
export default {
	name: 'DeleteComfirmDialog',
	props:{
		visible: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: '',
		},
		content: {
			type: String,
			default: ''
		},
		cancel: {
			type: String,
			default: 'Cancel'
		},
		okText: {
			type: String,
			default: 'Ok'
		}
	}
}
</script>
<style lang="scss" scoped>
.dialog {
	padding: 20px;
}
.main-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.content-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
</style>